export const reportColumns = [
  { header: "SL", key: "Master_id" },
  { header: "Products Name", key: "products_name" },
  { header: "Pack Sizes", key: "pack_sizes" },

  { header: "Credit Price", key: "credit_rate", isNumeric: true, group: "credit" },
  { header: "Ctn.", key: "credit_qty", isNumeric: true, group: "credit" },
  { header: "(Kg/Lit/Pcs.)", key: "credit_alt_qty", isNumeric: true, group: "credit" },
  { header: "Total (Kg/Lit/Pcs.)", key: "total_credit_alt_qty", isNumeric: true, group: "credit" },
  { header: "Credit Sales (Tk.)", key: "credit_amount", isNumeric: true, group: "credit" },
  { header: "Total (Tk.)", key: "total_credit_sales_amount", isNumeric: true, group: "credit" },

  { header: "Cash Price", key: "cash_rate", isNumeric: true, group: "cash" },
  { header: "Ctn.", key: "cash_qty", isNumeric: true, group: "cash" },
  { header: "(Kg/Lit/Pcs.)", key: "cash_alt_qty", isNumeric: true, group: "cash" },
  { header: "Total (Kg/Lit/Pcs.)", key: "total_cash_alt_qty", isNumeric: true, group: "cash" },
  { header: "Cash Sales (Tk.)", key: "cash_amount", isNumeric: true, group: "cash" },
  { header: "Total (Tk.)", key: "total_cash_sales_amount", isNumeric: true, group: "cash" },

  { header: "Grand Total (Ctn.)", key: "total_quantity", isNumeric: true, group: "grand" },
  { header: "Grand Total (Kg/Lit/Pcr.)", key: "alt_quantity", isNumeric: true, group: "grand" },
  { header: "Grand Total (Tk.)", key: "total_amount", isNumeric: true, group: "grand" },
];

// Columns that should only render a value on the FIRST row of a
// bill_no + bill_type + party_name + products_name group — matches the
// blanked-out "Total (Kg/Lit/Pcr.)" / "Total (Tk.)" cells in the source report
export const hiddenRepeatKeys = [
  "total_credit_alt_qty",
  "total_credit_sales_amount",
  "total_cash_alt_qty",
  "total_cash_sales_amount",
];

// The row grouping key used everywhere (table + excel) to decide
// which rows are "repeats" of the same product across pack sizes
export const groupKeyFields = ["bill_no", "bill_type", "party_name", "products_name"];

// Visual band colors matching the screenshot (blue = credit, green = cash)
export const groupStyles = {
  credit: { header: "bg-blue-100", cell: "bg-blue-50" },
  cash: { header: "bg-green-100", cell: "bg-green-50" },
  grand: { header: "bg-slate-100", cell: "" },
};

export const GROUP_LABELS = {
  credit: "Credit",
  cash: "Cash",
  grand: "Grand Total",
};

export const freeQuantityReportColumns=[
  { header: "SL", key: "SL" },
  { header: "Products", key: "products_name" },
  { header: "Pack Sizes", key: "pack_sizes" },
  { header: "July", key: "jul_free_qty", isNumeric:true },
  { header: "Aug", key: "aug_free_qty", isNumeric: true },
  { header: "Sep", key: "sep_free_qty", isNumeric: true },
  { header: "Oct", key: "oct_free_qty", isNumeric: true },
  { header: "Nov", key: "nov_free_qty", isNumeric: true },
  { header: "Dec", key: "dec_free_qty", isNumeric: true },
  { header: "jan", key: "jan_free_qty", isNumeric: true },
  { header: "Feb", key: "feb_free_qty", isNumeric: true },
  { header: "Mar", key: "mar_free_qty", isNumeric: true },
  { header: "Apr", key: "apr_free_qty", isNumeric: true },
  { header: "May", key: "may_free_qty", isNumeric: true },
  { header: "Jun", key: "jun_free_qty", isNumeric: true },
  { header: "Total Free Qty", key: "grand_total_qty", isNumeric: true },
  { header: "Ctn/Bag/Pcs", key: "uom" },
  { header: "Quantity", key: "free_qty", isNumeric: true },
  { header: "Kgs/Lit/Pcs", key: "alt_uom" },
  { header: "Alt Quantity", key: "alt_qty", isNumeric: true },
  { header: "Total Alternate Quantity", key: "total_alt_qty", isNumeric: true },
  { header: "Rate", key: "product_rate", isNumeric: true },
  { header: "Amount(Tk.)", key: "amount", isNumeric: true },
  { header: "Grand Total(Tk.)", key: "grand_total_amount", isNumeric: true }, 
];

export const productProfitabilityColumns=[
  { header: "SL No.", key: "sl" },
  { header: "Item Name", key: "product_name" },
  { header: "Pack Size", key: "pack_size" },
  { header: "Godown Name", key: "godown_name" },
  { header: "Quantity", key: "quantity", isNumeric: true },
  { header: "Total Quantity", key: "total_quantity", isNumeric: true },
  { header: "Rate", key: "rate", isNumeric: true },
  { header: "Amount", key: "amount", isNumeric: true },
  { header: "Total Amount", key: "total_amount", isNumeric: true },
  { header: "Consumption", key: "consumption", isNumeric: true },
  { header: "Total Consumption", key: "total_consumption", isNumeric: true },
  { header: "Profit", key: "gross_profit", isNumeric: true },
  { header: "Total Profit", key: "total_profit", isNumeric: true },
  { header: "Profit Percent", key: "profit_percent" },
]

export const customerProfileColumns = [
  // { header: "SL No.", key: "sl" },
  { header: "Invoice Date", key: "bill_date" },
  { header: "Invoice No.", key: "bill_no" },
  { header: "Invoice Type", key: "bill_type"},
  { header: "Product Name", key: "products_name" },
  { header: "Pack Size", key: "pack_sizes" },
  { header: "Ctn/Bag/Pcs", key: "uom" },
  { header: "Quantity", key: "quantity", isNumeric: true },
  { header: "Total Quantity", key: "total_quantity", isNumeric: true },
  { header: "Kg/Lit/Pcs", key: "alt_uom" },
  { header: "Alternate Quantity", key: "alt_qty", isNumeric: true },
  { header: "Total Alternate Quantity", key: "total_alt_qty", isNumeric: true },
  { header: "Rate", key: "rate", isNumeric: true },
  { header: "Free Quantity", key: "free_qty", isNumeric: true },
  { header: "Total Free Quantity", key: "total_free_qty", isNumeric: true },
  { header: "Amount", key: "amount", isNumeric: true },
  { header: "Total Amount", key: "grand_total", isNumeric: true },
  { header: "Payment Date", key: "payment_date" },
  { header: "Opening Balance", key: "opening_balance", },
  { header: "Paid Amount", key: "paid_amount", isNumeric: true },
  { header: "Discount", key: "discount_amount", isNumeric: true },
  { header: "Closing Balance", key: "closing_balance", },
  { header: "Receipt Invoice No.", key: "receipt_no" },
];

export const seasonWiseTransactionColumns = [
  { header: "SL No.", key: "sl" },
  { header: "Invoice Date", key: "bill_date" },
  { header: "Invoice No.", key: "bill_no" },
  { header: "Invoice Type", key: "bill_type" },
  { header: "Party Name", key: "party_name" },
  { header: "Product Name", key: "products_name" },
  { header: "Pack Size", key: "pack_sizes" },
  { header: "Ctn/Bag/Pcs", key: "uom" },
  { header: "Quantity", key: "quantity", isNumeric: true },
  { header: "Total Quantity", key: "total_quantity", isNumeric: true },
  { header: "Kgs/Lit/Pcs", key: "alt_uom" },
  { header: "Alternate Quantity", key: "alt_qty", isNumeric: true },
  { header: "Total Alternate Quantity", key: "total_alt_qty", isNumeric: true },
  { header: "Rate", key: "rate", isNumeric: true },
  { header: "Amount", key: "amount", isNumeric: true },
  { header: "Total Amount", key: "total_amount", isNumeric: true },
  { header: "Region", key: "region_name" },
];


export const centralLocationStockColumns =[
{ header: "SL No.", key: "sl" },
{ header: "Product Name", key: "product_name" },
{ header: "Godown Name", key: "godown_name" },
{ header: "Pack Size", key: "pack_size" },
{ header: "Ctn/Bag/Pcs", key: "uom" },
{ header: "Quantity", key: "total_quantity", isNumeric: true },
{ header: "Total Quantity", key: "grand_total_qty", isNumeric: true },
{ header: "Kgs/Lit/Pcs", key: "alt_uom" },
{ header: "Alternate Quantity", key: "alt_quantity", isNumeric: true },
{ header: "Total Alternate Quantity", key: "total_alt_qty", isNumeric: true },
{ header: "Rate", key: "rate", isNumeric: true },
{ header: "Amount", key: "amount", isNumeric: true },
{ header: "Total Amount", key: "total_amount", isNumeric: true },

];